import { Box, Tabs, Tab, TabList } from '@chakra-ui/react';
import { LDFlagSet } from 'launchdarkly-js-sdk-common';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import React from 'react';
import { useHistory } from 'react-router-dom';

const tabIndexes = {
  'outstanding-ledger': 0,
  'expenses-fees': 1,
  'monthly-summary': 2,
};

export const StatementsTemplate = withLDConsumer()(
  ({
    children,
    selectedTab,
    flags,
  }: {
    children: React.ReactChild | React.ReactChild[];
    selectedTab: 'outstanding-ledger' | 'expenses-fees' | 'monthly-summary';
    flags?: LDFlagSet;
  }) => {
    const history = useHistory();

    return (
      <>
        <Tabs
          variant="line"
          index={tabIndexes[selectedTab]}
          colorScheme="black"
        >
          <TabList>
            <Tab onClick={() => history.push('/statements/outstanding-ledger')}>
              Outstanding Ledger
            </Tab>
            <Tab onClick={() => history.push('/statements/expenses-fees')}>
              Expenses &amp; Fees
            </Tab>
            {flags?.isStatementsMonthlySummaryEnabled && (
              <Tab onClick={() => history.push('/statements/monthly-summary')}>
                Monthly Summary
              </Tab>
            )}
          </TabList>
        </Tabs>
        <Box mt="25px" padding="10px">
          {children}
        </Box>
      </>
    );
  },
);
